import {
  EmilyClient,
  TCPAClient,
  getTrustedFormFieldValues,
} from '@clearlink/emily'
import { serviceURLs } from '../../../environment-config'
import AddressQualification from './AddressQualification'

const emilySubmit = async ({
  formRef,
  values,
  setShowSubmissionMessage,
  setShowSubmissionErrorMessage,
  smartyStreetsWebsiteKey,
  addressQualificationCode,
}) => {
  const sanitizedData = {}

  // Transform any select boxes to their values
  for (const [key, value] of Object.entries(values)) {
    sanitizedData[key] =
      value.value && typeof value === 'object' ? value.value : value
  }

  getTrustedFormFieldValues(formRef)
    .then(async (trustedFormFields) => {
      const emily = new EmilyClient(serviceURLs.emilyURL)
      const tcpa = new TCPAClient(serviceURLs.tcpaURL)

      const data = {
        ...sanitizedData,
        ...trustedFormFields,
      }

      if (data.address && smartyStreetsWebsiteKey) {
        if (addressQualificationCode) {
          const addressQual = new AddressQualification({
            addressQualificationCode,
            smartyStreetsWebsiteKey,
          })

          await addressQual
            .sendQualificationData(
              data.address,
              data?.zip_postal,
              data.request_id
            )
            .then(() => {
              tcpa
                .submit(data, true) // always setting to true because they can't submit form without the checkbox or without a disclaimer being present saying we can contact them
                .then(() => emily.submit(data))
                .then(() => setShowSubmissionMessage(true))
                .catch((err) => {
                  setShowSubmissionErrorMessage(true)
                  console.error(
                    `Leshen:UI - failed to submit lead: ${err.message}`
                  )
                })
            })
            .catch((err) => {
              setShowSubmissionErrorMessage(true)
              console.error(
                `Leshen:UI - failed to qualify data in AQS: ${err.responseText}`
              )
            })
        }
      } else {
        await tcpa
          .submit(data, true) // always setting to true because they can't submit form without the checkbox or without a disclaimer being present saying we can contact them
          .then(() => emily.submit(data))
          .then(() => setShowSubmissionMessage(true))
          .catch((err) => {
            setShowSubmissionErrorMessage(true)
            console.error(`Leshen:UI - failed to submit lead: ${err.message}`)
          })
      }

      return null
    })
    .catch(() =>
      console.error('Leshen:UI - failed to load trusted form fields')
    )
}

export const emilyTCPAUpdate = async ({ formRef, values, consentGiven }) => {
  getTrustedFormFieldValues(formRef.current)
    .then(async (trustedFormFields) => {
      const tcpa = new TCPAClient(serviceURLs.tcpaURL)

      const data = {
        ...values,
        ...trustedFormFields,
      }

      if (data.phone_number.length !== 10) {
        return
      }

      await tcpa.submit(data, consentGiven).catch((err) => {
        console.error(
          `Leshen:UI - failed to update lead's TCPA: ${err.message}`
        )
      })
    })
    .catch(() =>
      console.error('Leshen:UI - failed to load trusted form fields')
    )
}

export default emilySubmit
